var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "input-controls",
        "type--" + _vm.genericType,
        !_vm.showFilterInput && _vm.type !== "text" ? "pa-0" : ""
      ]
    },
    [
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showFilterInput,
              expression: "!showFilterInput"
            }
          ],
          attrs: { icon: "" },
          on: { click: _vm.enableFilter }
        },
        [
          _c("span", [
            _vm._v("\n      " + _vm._s(_vm.filterLabel.text) + "\n    ")
          ]),
          _vm._v(" "),
          _c("v-icon", { staticClass: "material-icons" }, [
            _vm._v("\n      " + _vm._s(_vm.filterLabel.icon) + "\n    ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFilterInput,
              expression: "showFilterInput"
            }
          ],
          staticClass: "input-boxes"
        },
        [
          _vm.type !== "text"
            ? _c("global-dropdown", {
                staticClass: "filter-type-dropdown",
                attrs: {
                  options: _vm.filterTypeOptions,
                  size: 24,
                  "min-width": 24
                },
                on: { change: _vm.changeFilterType },
                model: {
                  value: _vm.selectedFilter,
                  callback: function($$v) {
                    _vm.selectedFilter = $$v
                  },
                  expression: "selectedFilter"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDateType
            ? [
                _c(
                  "calendar-popup",
                  {
                    ref: "datePicker",
                    attrs: { value: _vm.value, "min-date": "1900-01-01" },
                    on: { input: _vm.updateValue }
                  },
                  [
                    _c("input", {
                      staticClass: "filter-input-display",
                      attrs: { disabled: "", autocomplete: "off" },
                      domProps: { value: _vm.value }
                    })
                  ]
                )
              ]
            : [
                _c("input", {
                  ref: "filterBox",
                  staticClass: "filter-input-display",
                  attrs: { type: _vm.type, autocomplete: "off" },
                  domProps: { value: _vm.value },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return (function(e) {
                        return _vm.updateValue(e.target.value)
                      })($event)
                    },
                    blur: function(e) {
                      return _vm.updateValue(e.target.value)
                    }
                  }
                })
              ],
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "clear-filter",
              attrs: { title: "Clear input field", dense: "" },
              on: { click: _vm.closeFilter }
            },
            [_vm._v("\n      close\n    ")]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }